import Warning from '~/errors/Warning';

class ResponseError extends Warning {
    response: unknown;

    constructor(message: string, response?: unknown) {
        super(message);
        this.response = response;
        this.productionMessage =
            'Phản hồi không hợp lệ. Vui lòng thử lại sau.';

        this.name = 'ResponseError';
    }
}

export default ResponseError;
